import LifecyclePill from '../LifecyclePill';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

// Only the two settable states appear as menu rows — 'enabled'/'disabled' are
// data-only and never offered here. Two items, so the rows are written out
// explicitly rather than looped.
const LifecycleMenu: FunctionComponent<Props> = ({
    className = '',
    lifecycleLabels,
    onSelect,
    testId = TEST_ID
}) => {
    const t = useTranslation();

    return (
        <VerticalContainer className={`${styles.lifecycleMenu} ${className}`} testId={testId}>
            <Wrapper className={styles.menuRow} onClick={() => onSelect('claimed')}>
                <LifecyclePill label={lifecycleLabels.claimed} status='claimed' />

                <Wrapper className={styles.definition}>{t.LIFECYCLE_DEFINITION_CLAIMED}</Wrapper>
            </Wrapper>

            <Wrapper className={styles.menuRow} onClick={() => onSelect('released')}>
                <LifecyclePill label={lifecycleLabels.released} status='released' />

                <Wrapper className={styles.definition}>{t.LIFECYCLE_DEFINITION_RELEASED}</Wrapper>
            </Wrapper>
        </VerticalContainer>
    );
};

export default LifecycleMenu;
